import * as React from "react";
const SvgFiRrMaskSnorkel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mask-snorkel_svg__a)">
      <path
        fill="#062147"
        d="M10 9.03c.165.103.605.449 1.337 1.542A3.2 3.2 0 0 0 14 12c3.309 0 6-2.691 6-6s-2.691-6-6-6H6C2.691 0 0 2.691 0 6s2.691 6 6 6a3.2 3.2 0 0 0 2.663-1.429C9.395 9.479 9.835 9.133 10 9.03m-2.998.427A1.21 1.21 0 0 1 6 10c-2.206 0-4-1.794-4-4s1.794-4 4-4h8c2.206 0 4 1.794 4 4s-1.794 4-4 4a1.21 1.21 0 0 1-1.002-.542C11.874 7.781 10.921 7 10 7s-1.875.781-2.998 2.457M24 1v15.5c0 4.136-3.364 7.5-7.5 7.5S9 20.636 9 16.5V15a1 1 0 1 1 2 0v1.5c0 3.032 2.468 5.5 5.5 5.5s5.5-2.468 5.5-5.5V1a1 1 0 1 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mask-snorkel_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMaskSnorkel;
